export const EMAIL_BUILDER_SETTINGS_SHEET_SNAP_POINTS = [0.55, 0.92];
export const EMAIL_BUILDER_SETTINGS_SHEET_DEFAULT_SNAP_POINT = 0.55;
